import { render, staticRenderFns } from "./vsRow.vue?vue&type=template&id=18dbc4b6&lang=html"
import script from "./vsRow.vue?vue&type=script&lang=js"
export * from "./vsRow.vue?vue&type=script&lang=js"
import style0 from "./vsRow.vue?vue&type=style&index=0&id=18dbc4b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports